import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { notificationService } from '@/lib/services/notification.service';
import { logger } from '@/lib/utils/logger';
import { installMcp, USER_MCP_QUERY_KEYS } from '../../api';

export const useInstallMcp = () => {
  const { t } = useTranslation('admin');
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      mcpCatalogId,
      headers,
    }: {
      mcpCatalogId: string;
      headers?: Record<string, string>;
    }) => installMcp(mcpCatalogId, headers),
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({ queryKey: USER_MCP_QUERY_KEYS.installed });
      // Bust any stale cached /test result (e.g. a quick uninstall→reinstall) so health re-checks.
      await queryClient.invalidateQueries({
        queryKey: USER_MCP_QUERY_KEYS.health(variables.mcpCatalogId),
      });
      notificationService.showSuccess(t('userMcpServers.useInstallMcp.mcpServerInstalled'));
    },
    onError: (error) => {
      notificationService.showError(t('userMcpServers.useInstallMcp.failedToInstallMcpServer'));
      logger.error('Failed to install MCP:', error);
    },
  });
};
